import Lottie from 'lottie-react';
import loadingAnimation from '../../assets/animations/loader.json';
import React from 'react';
import './page-loader.scss';

const SiteLoader = () => {
  return (
    <div className={'page-loader'}>
      <Lottie animationData={loadingAnimation} loop={true} className={'page-loader__animation'} />
    </div>);
};
export default SiteLoader;
